import { useState } from 'react';

export default function Trial() {
  const benefits = [
    {
      icon: "ri-gift-line",
      title: "完全免費",
      description: "一整堂實際課程完整參與試聽，無隱藏費用"
    },
    {
      icon: "ri-user-line",
      title: "個別評估",
      description: "專業老師個別評估學習狀況與需求"
    },
    {
      icon: "ri-book-open-line",
      title: "客製化建議",
      description: "根據試聽結果提供個人化學習建議"
    },
    {
      icon: "ri-time-line",
      title: "彈性安排",
      description: "可依您的時間需求安排試聽時段"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-pink-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-pink-500" style={{fontFamily: '"Pacifico", serif'}}>
                共學趣線上國語文寫作教室
              </h1>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <a href="/" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer">首頁</a>
                <a href="/courses" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer">課程介紹</a>
                <a href="/teachers" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer">師資團隊</a>
                <a href="/results" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer">教學成果</a>
                <a href="/trial" className="text-pink-500 font-medium px-3 py-2 rounded-md text-sm whitespace-nowrap cursor-pointer">免費試聽</a>
              </div>
            </div>
            <div className="md:hidden">
              <button className="text-gray-700 hover:text-pink-500 w-6 h-6 flex items-center justify-center cursor-pointer">
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-pink-50 to-rose-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            免費試聽申請
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            體驗我們的專業教學，讓孩子在輕鬆愉快的環境中發現寫作的樂趣。
            立即申請免費試聽，開啟孩子的寫作之旅！
          </p>
          <div className="bg-yellow-100 border border-yellow-300 rounded-lg p-4 max-w-2xl mx-auto">
            <p className="text-yellow-800 font-medium">
              <i className="ri-information-line mr-2"></i>
              目前試聽開放課程：中階/高階/國中/文言文/成語 五種課程
            </p>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              免費試聽優勢
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              我們提供完整的試聽體驗，讓您和孩子充分了解我們的教學方式
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            {benefits.map((benefit, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${benefit.icon} text-2xl text-pink-500`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{benefit.title}</h3>
                <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* LINE預約區塊 */}
      <section className="py-20 bg-pink-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-12 text-center">
            <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-8">
              <i className="ri-line-fill text-5xl text-green-500"></i>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              透過官方LINE預約試聽
            </h2>
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              加入我們的官方LINE帳號，即可快速預約免費試聽課程。<br />
              我們會在24小時內與您聯繫安排試聽時間！
            </p>
            <div className="bg-gray-50 rounded-xl p-6 mb-8 max-w-md mx-auto">
              <p className="text-gray-700 mb-2">官方LINE ID</p>
              <p className="text-2xl font-bold text-green-600">@write123</p>
            </div>
            <a 
              href="https://lin.ee/3Slg6R2Zx" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center bg-green-500 text-white px-10 py-4 rounded-lg font-semibold text-lg hover:bg-green-600 transition-colors whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
            >
              <i className="ri-line-fill mr-3 text-2xl"></i>
              立即加入官方LINE預約試聽
            </a>
            <p className="text-gray-500 mt-6 text-sm">
              點擊按鈕即可加入LINE好友，直接與我們聯繫預約試聽
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <h3 className="text-2xl font-bold mb-4 text-pink-400" style={{fontFamily: '"Pacifico", serif'}}>
                共學趣線上國語文寫作教室
              </h3>
              <p className="text-gray-400 mb-6 leading-relaxed">
                專業線上寫作教室，致力於培養孩子的寫作能力與創意思維。
                我們相信每個孩子都有無限潛能，只需要正確的引導。
              </p>
              <div className="flex gap-4">
                <a href="https://lin.ee/3Slg6R2Zx" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors cursor-pointer">
                  <i className="ri-line-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors cursor-pointer">
                  <i className="ri-instagram-fill text-lg"></i>
                </a>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">快速連結</h4>
              <ul className="space-y-2">
                <li><a href="/courses" className="text-gray-400 hover:text-white transition-colors cursor-pointer">課程介紹</a></li>
                <li><a href="/teachers" className="text-gray-400 hover:text-white transition-colors cursor-pointer">師資團隊</a></li>
                <li><a href="/results" className="text-gray-400 hover:text-white transition-colors cursor-pointer">教學成果</a></li>
                <li><a href="/trial" className="text-gray-400 hover:text-white transition-colors cursor-pointer">免費試聽</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">聯絡資訊</h4>
              <ul className="space-y-2 text-gray-400">
                <li className="flex items-center gap-2">
                  <i className="ri-line-fill"></i>
                  <a href="https://lin.ee/3Slg6R2Zx" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">@write123</a>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-fill"></i>
                  <span>週一至週日 9:00-21:00</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-global-fill"></i>
                  <span>線上教學，不限地區</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2025 共學趣線上寫作教室. All rights reserved. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer ml-2">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
